export const fetchAllRegions = () => {
  return axios.get(`service/regions/all`);
};

export default {
  fetchAllRegions
};
